import PollerSequential from '@shell/utils/poller-sequential';
import { _MERGE } from '@shell/plugins/dashboard-store/actions';

/*
* Moved this logic that was previously a shim in the store. that subscribed all
* resources called. Now this util will server in an al la carte fashion to start/stop
* polling on specific resource types as needed by particular lists or pages.
*/

const pollingRate = 30000; //30 seconds
const polling: any = {};

export function startPolling(types: string[], store: any): any {
  types.forEach((type) => {
    if (store.getters['type-map/isSpoofed'](type)) {
      // Ignore spoofed
      return;
    }

    // Stop any existing poller for this type before starting a new one
    polling[type]?.stop();

    // Create and start a new poller for the specified type
    polling[type] = new PollerSequential(
      async() => {
        await store.dispatch('epinio/findAll', { type, opt: { force: true, load: _MERGE } });
      },
      pollingRate,
      5
    );

    // Start the poller immediately
    if (polling[type] !== undefined) {
      polling[type].start();
    }
  });
}

// Stop polling for the specified types
export function stopPolling(types: string[]): any {
  types.forEach((type) => {
    if (polling[type] !== undefined) {
      polling[type].stop();
    }
  });
}
